/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Submit_ProductInputs */

const en_directory_hubs_submit_product = /** @type {(inputs: Directory_Hubs_Submit_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a product`)
};

const zh_directory_hubs_submit_product = /** @type {(inputs: Directory_Hubs_Submit_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交产品`)
};

/**
* | output |
* | --- |
* | "Submit a product" |
*
* @param {Directory_Hubs_Submit_ProductInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_submit_product = /** @type {((inputs?: Directory_Hubs_Submit_ProductInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Submit_ProductInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_submit_product(inputs)
	return zh_directory_hubs_submit_product(inputs)
});
export { directory_hubs_submit_product as "directory.hubs.submit_product" }